import { DistanceFilter, SearchFilter } from '@unmapped/core/filters';
import { useStore } from '@unmapped/core/hooks';
import { locationNameAlphaSort } from '@unmapped/core/state';
import { useEffect, useMemo, useRef } from 'react';
import { adapterMap } from './definitions/shared';
import { action } from 'mobx';
import React from 'react';
export const useFilterSet = dataset => {
  const filters = useMemo(() => [new DistanceFilter('distance', {
    initialRadius: 25,
    initialUnit: 'mi'
  }), new SearchFilter('search')], []);
  const initialRenderRef = useRef(true);
  useEffect(() => {
    if (initialRenderRef.current) {
      // don't update on first render because filters are already initialized with correct values
      initialRenderRef.current = false;
      return;
    }
    action('useFilterSet.kindUpdate', () => {
      //     const operatorFilter = filters[2] as FlagFilter<AnyFields, 'operator', AnyResult>;
      //     operatorFilter.options = dataset === 'school' ? SchoolOperator : CemeteryOperator,
      //     operatorFilter.visible = dataset === 'school' ||  dataset === 'cemetery';
    })();
  }, [dataset]);
  return filters;
};
export const useDataSource = (dataset, store) => {
  const initialRenderRef = useRef(true);
  useEffect(() => {
    if (initialRenderRef.current) {
      // don't update on first render because filters are already initialized with correct values
      initialRenderRef.current = false;
      return;
    }
    if (store.adapter !== adapterMap[dataset]) {
      action('useFilterSet.kindUpdate', () => {
        store.adapter = adapterMap[dataset];
      })();
    }
  }, [dataset]);
};
export const useSortManager = () => {
  const store = useStore();
  useEffect(action('useSortManager', () => {
    if (store.filterMap.search.state) {
      if (store.sort.label !== 'Relevance') {
        store.updateSort({
          label: 'Relevance',
          comparator: SearchFilter.createComparator('search'),
          direction: 'desc'
        });
      }
    } else if (store.filterMap.distance.state) {
      if (store.sort.label !== 'Distance') {
        store.updateSort({
          label: 'Distance',
          comparator: DistanceFilter.createComparator('distance'),
          direction: 'asc'
        });
      }
    } else if (store.sort.label !== 'Name') {
      store.updateSort({
        label: 'Name',
        comparator: locationNameAlphaSort,
        direction: 'desc'
      });
    }
  }), [store.filterMap.search.state, store.filterMap.distance.state]);
};
export const FocusedLocationContext = /*#__PURE__*/React.createContext({
  focusedLocation: null,
  setFocusedLocation: () => {}
});
export const useIsMobile = () => {
  const screenSize = useRef(0);
  useEffect(() => {
    window.addEventListener("resize", () => {
      screenSize.current = window.innerWidth;
    });
    return () => {
      window.removeEventListener("resize", () => {
        screenSize.current = window.innerWidth;
      });
    };
  }, []);
  return screenSize.current <= 768;
};